import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Save, Upload, Package } from "lucide-react";
import "../styles/admin-dashboard.css";

const AddProduct = () => {
  const navigate = useNavigate();
  const { masp } = useParams();
  const isEditing = !!masp;

  // Khởi tạo state với đầy đủ 16 trường
  const [formData, setFormData] = useState({
    tensp: "",
    mota: "",
    maloaisp: "",
    dongSanPham: "",
    khoiluong: "",
    donViTinh: "",
    xuatXu: "",
    hanSuDung: "",
    thanhPhan: "",
    baoQuan: "",
    moTaChiTiet: "",
    motaphu: "",
    huongDanSuDung: "",
    chiTieuChatLuong: ""
  });
  
  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditing) {
      axios.get(`https://dht.api.mekongzone.com.vn/api/products/${masp}`)
        .then(res => {
          const d = res.data;
          // Xử lý moTaChiTiet: Nếu là mảng JSON thì join thành text xuống dòng để hiển thị
          let detailsText = d.moTaChiTiet;
          if (Array.isArray(d.moTaChiTiet)) {
              detailsText = d.moTaChiTiet.join('\n');
          }

          setFormData({
            tensp: d.tensp || "",
            mota: d.mota || "",
            maloaisp: d.maloaisp || "",
            dongSanPham: d.dongSanPham || "",
            khoiluong: d.khoiluong || "",
            donViTinh: d.donViTinh || "",
            xuatXu: d.xuatXu || "",
            hanSuDung: d.hanSuDung || "",
            thanhPhan: d.thanhPhan || "",
            baoQuan: d.baoQuan || "",
            moTaChiTiet: detailsText || "",
            motaphu: d.motaphu || "",
            huongDanSuDung: d.huongDanSuDung || "",
            chiTieuChatLuong: d.chiTieuChatLuong || ""
          });
          setPreviewImage(d.hinhanh);
        })
        .catch(err => alert("Lỗi tải dữ liệu sản phẩm"));
    }
  }, [masp, isEditing]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    Object.keys(formData).forEach(key => {
        data.append(key, formData[key]);
    });
    
    if (imageFile) {
      data.append("hinhanh", imageFile);
    }

    try {
      if (isEditing) {
        await axios.put(`https://dht.api.mekongzone.com.vn/api/products/${masp}`, data);
        alert("✅ Cập nhật thành công!");
      } else {
        await axios.post("https://dht.api.mekongzone.com.vn/api/products", data);
        alert("✅ Thêm mới thành công!");
      }
      navigate("/admin/dashboard");
    } catch (error) {
      alert("Lỗi: " + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const formGroupStyle = { marginBottom: 15 };
  const labelStyle = { display: 'block', fontWeight: 600, marginBottom: 5, fontSize: '0.9rem', color: '#374151' };
  const inputStyle = { width: '100%', padding: '10px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: '0.95rem' };

  return (
    <div className="admin-layout" style={{ justifyContent: 'center', padding: '30px' }}>
      <div style={{ width: '100%', maxWidth: 900, background: 'white', padding: 30, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 25, borderBottom: '1px solid #eee', paddingBottom: 15 }}>
            <button onClick={() => navigate('/admin/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}><ArrowLeft /></button>
            <h2 style={{ margin: 0, fontSize: '1.5rem', display:'flex', alignItems:'center', gap: 10 }}>
                <Package color="#2563eb" /> {isEditing ? `Sửa Sản Phẩm #${masp}` : "Thêm Sản Phẩm Mới"}
            </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 30 }}>
            
            {/* CỘT TRÁI */}
            <div>
                <h4 style={{marginTop:0, color:'#2563eb', borderBottom:'2px solid #e2e8f0', paddingBottom:5}}>1. Thông Tin Chung</h4>
                
                <div style={formGroupStyle}>
                    <label style={labelStyle}>Tên Sản Phẩm (*)</label>
                    <input type="text" name="tensp" value={formData.tensp} onChange={handleChange} required style={inputStyle} />
                </div>

                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>Mã Loại SP</label>
                        <input type="number" name="maloaisp" value={formData.maloaisp} onChange={handleChange} style={inputStyle} />
                    </div>
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>Dòng Sản Phẩm</label>
                        <input type="text" name="dongSanPham" value={formData.dongSanPham} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>

                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>Khối Lượng</label>
                        <input type="text" name="khoiluong" value={formData.khoiluong} onChange={handleChange} style={inputStyle} />
                    </div>
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>Đơn Vị Tính</label>
                        <input type="text" name="donViTinh" value={formData.donViTinh} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Xuất Xứ</label>
                    <input type="text" name="xuatXu" value={formData.xuatXu} onChange={handleChange} style={inputStyle} />
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Hình Ảnh Đại Diện</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 15, border: '1px dashed #ccc', padding: 10, borderRadius: 6 }}>
                        {previewImage ? 
                            <img src={previewImage} alt="Preview" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4 }} /> 
                            : <div style={{width:60, height:60, background:'#f3f4f6', borderRadius:4}}></div>
                        }
                        <label className="btn" style={{ background: '#2563eb', color: 'white', padding: '6px 12px', fontSize: '0.8rem' }}>
                            <Upload size={14} /> Tải ảnh
                            <input type="file" onChange={handleImageChange} hidden accept="image/*" />
                        </label>
                    </div>
                </div>
            </div>

            {/* CỘT PHẢI */}
            <div>
                <h4 style={{marginTop:0, color:'#2563eb', borderBottom:'2px solid #e2e8f0', paddingBottom:5}}>2. Chi Tiết & HDSD</h4>
                
                <div style={formGroupStyle}>
                    <label style={labelStyle}>Mô tả ngắn (Mota)</label>
                    <input type="text" name="mota" value={formData.mota} onChange={handleChange} style={inputStyle} />
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Mô tả chi tiết (Xuống dòng để tách ý)</label>
                    <textarea name="moTaChiTiet" value={formData.moTaChiTiet} onChange={handleChange} style={{...inputStyle, height: 80}} />
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Thành phần</label>
                    <textarea name="thanhPhan" value={formData.thanhPhan} onChange={handleChange} style={{...inputStyle, height: 60}} />
                </div>

                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                     <div style={formGroupStyle}>
                        <label style={labelStyle}>Hạn Sử Dụng</label>
                        <input type="text" name="hanSuDung" value={formData.hanSuDung} onChange={handleChange} style={inputStyle} />
                    </div>
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>Bảo Quản</label>
                        <input type="text" name="baoQuan" value={formData.baoQuan} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>
                
                 <div style={formGroupStyle}>
                    <label style={labelStyle}>Hướng dẫn sử dụng</label>
                    <input type="text" name="huongDanSuDung" value={formData.huongDanSuDung} onChange={handleChange} style={inputStyle} />
                </div>
            </div>
          </div>
          
           <div style={formGroupStyle}>
                <label style={labelStyle}>Mô tả phụ (Motaphu)</label>
                <input type="text" name="motaphu" value={formData.motaphu} onChange={handleChange} style={inputStyle} />
            </div>

            <div style={formGroupStyle}>
                <label style={labelStyle}>Chỉ tiêu chất lượng</label>
                <input type="text" name="chiTieuChatLuong" value={formData.chiTieuChatLuong} onChange={handleChange} style={inputStyle} />
            </div>


          <div style={{ marginTop: 30, display: 'flex', justifyContent: 'flex-end', gap: 15 }}>
             <button type="button" onClick={() => navigate('/admin/dashboard')} className="btn" style={{background:'#f3f4f6', color:'#374151'}}>Hủy</button>
             <button type="submit" className="btn btn-primary" style={{ padding: '12px 30px', fontSize:'1rem' }} disabled={loading}>
                <Save size={18} /> {loading ? "Đang lưu..." : "Lưu Sản Phẩm"}
             </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default AddProduct;